import React, {useState, useEffect, useRef} from "react"
import {useNavigate, useLocation, Link} from "react-router-dom"
import api, {requestFailed} from "../Scripts/api"

function Login() {

    const location = useLocation()
    const redirect = location.state?.redirect
    const navigate = useNavigate()
    const emailRef = useRef(null)
    const usernameRef = useRef(null)
    const passwordRef = useRef(null)
    const confirmRef = useRef(null)
    const inputRefs = [emailRef, usernameRef, passwordRef, confirmRef]
    const [state, setState] = useState("login")
    const [email, setEmail] = useState('')
    const [username, setUsername] = useState('')
    const [password, setPassword] = useState('')
    const [confirm, setConfirm] = useState('')
    const [status, setStatus] = useState('')

    const resetFields = () => {
        for (var i = 0; i < inputRefs.length; i++) {
            if (inputRefs[i].current) {
                inputRefs[i].current.value = ''
                inputRefs[i].current.classList.remove("logininputinvalid")
            }
        }
        setEmail('')
        setUsername('')
        setPassword('')
        setConfirm('')
        setStatus('')
    }

    const setLoginState = (str) => {
        setState(str)
        resetFields()
    }

    const validFields = () => {
        const emailRegex = /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/
        const usernameRegex = /^[a-zA-Z0-9_]{3,32}$/
        const reservedUsernames = ["ai", "login", "post", "explore", "create", "challenge", "about", "help", "legal", "settings", "profile", "guides", "liked"]
        const passwordRegex = /^[A-Za-z\d@$!%*?&.,\-_(){}\[\]`~;:#^+=]{8,}$/
        var invalidStatus = ''

        if (!emailRegex.test(email)) {
            emailRef.current.classList.add("logininputinvalid")
            invalidStatus += "invalid email\n"
        } if (!usernameRegex.test(username) || reservedUsernames.includes(username.toLowerCase())) {
            usernameRef.current.classList.add("logininputinvalid")
            invalidStatus += "invalid username\n"
        } if (!passwordRegex.test(password)) {
            passwordRef.current.classList.add("logininputinvalid")
            confirmRef.current.classList.add("logininputinvalid")
            invalidStatus += "password must contain at least 8 characters and only the following special characters: @$!%*?&.,-_(){}[]~;:#^+="
        } else if (confirm !== password) {
            passwordRef.current.classList.add("logininputinvalid")
            confirmRef.current.classList.add("logininputinvalid")
            invalidStatus += "passwords do not match"
        }
        if (invalidStatus) {
            setStatus(invalidStatus)
            return false
        } return true
    }

    const handleNext = () => {
        if (state === "login") login()
        else if (state === "signup") signup()
    }

    const signup = () => {
        if (validFields()) {
            setStatus('')
            api.post(`/api/signup`, {
                email: email,
                username: username,
                password: password
            }).then((response) => {
                if (response.data.account) {
                    setLoginState("login")
                    setStatus("account created — log in")
                }
            }).catch((error) => {
                const {status: statusCode} = requestFailed(error)
                const data = error.response?.data
                if (!data) {
                    setStatus("something went wrong — please try again")
                    return
                }
                setStatus(data.message)
                if (data.code === "BOTH_TAKEN" || data.code === "BAD_EMAIL" || data.code === "EMAIL_TAKEN") {
                    emailRef.current.classList.add("logininputinvalid")
                }
                if (data.code === "BOTH_TAKEN" || data.code === "BAD_USERNAME" || data.code === "USERNAME_TAKEN") {
                    usernameRef.current.classList.add("logininputinvalid")
                }
                if (data.code === "BAD_PASSWORD") {
                    passwordRef.current.classList.add("logininputinvalid")
                    confirmRef.current.classList.add("logininputinvalid")
                }
            })
        }
    }

    const login = () => {
        api.post(`/api/login`, {
            username: username,
            password: password
        }).then((response) => {
            if (redirect) navigate(redirect)
            else navigate("/@" + response.data.username + "/profile")
        }).catch((error) => {
            requestFailed(error)
            const data = error.response?.data
            if (!data) {
                setStatus("something went wrong — please try again")
                return
            }
            setStatus(data.message)
            if (data.code === "BAD_USERNAME") {
                usernameRef.current.classList.add("logininputinvalid")
                passwordRef.current.classList.add("logininputinvalid")
            } else if (data.code === "BAD_PASSWORD") {
                passwordRef.current.classList.add("logininputinvalid")
            }
        })
    }

    const handleInput = (e, i) => {
        switch (i) {
            case 0:
                setEmail(e.target.value)
                break
            case 1:
                setUsername(e.target.value)
                break
            case 2:
                setPassword(e.target.value)
                break
            case 3:
                setConfirm(e.target.value)
                break
        }
        inputRefs[i].current.classList.remove("logininputinvalid")
        setStatus('')
    }

    const handleKeyDown = (event) => {
        if (event.key === "Enter") {
            if (state === "login") login()
            else if (state === "signup") signup()
        }
    }

    useEffect(() => {
        api.get(`/api/login`).then((response) => {
            if (response.data.loggedIn) {
                if (redirect) navigate(redirect)
                else navigate("/@" + response.data.account + "/profile")
            }
        }).catch(requestFailed)
    }, [])

    return (
        <div id="loginbox" onKeyDown={handleKeyDown}>
            <div>
                <button className={state === "login" ? "loginbuttonactive" : "loginbutton"} onClick={() => setLoginState("login")}>log in</button>
                <button className={state === "signup" ? "loginbuttonactive" : "loginbutton"} onClick={() => setLoginState("signup")}>sign up</button>
            </div>
            {state === "signup" &&
                <div>
                    <label className="loginlabel">  e-mail: </label>
                    <input ref={emailRef} className="logininput" type="text" spellCheck="false" onChange={(e) => {handleInput(e, 0)}}></input>
                </div>
            }
            <div>
                <label className="loginlabel">username: </label>
                <input ref={usernameRef} className="logininput" type="text" spellCheck="false" onChange={(e) => {handleInput(e, 1)}}></input>
            </div>
            <div>
                <label className="loginlabel">password: </label>
                <input ref={passwordRef} className="logininput" type="password" spellCheck="false" onChange={(e) => {handleInput(e, 2)}}></input>
            </div>
            {state === "signup" &&
                <div>
                    <label className="loginlabel"> confirm: </label>
                    <input ref={confirmRef} className="logininput" type="password" spellCheck="false" onChange={(e) => {handleInput(e, 3)}}></input>
                </div>
            }
            {state === "signup" &&
                <p id="signuptos">By signing up you agree to the <Link to="/legal">terms of service</Link>.</p>}
            <button id="nextbutton" onClick={handleNext}>(&#62;&#62;)</button>
            {status && <pre id="loginstatus">{status}</pre>}
        </div>
    )
}

export default Login;
